import PropTypes from 'prop-types';

const Banner = ({ children, type }) => {
  let classes = [
    'bg-opacity-10',
    'rounded',
    'py-2',
    'px-4',
    'border',
    'text-sm',
    'transition',
    'duration-200',
  ];

  switch (type) {
    case 'warning':
      classes.push('bg-orange-400', 'text-orange-900', 'border-2', 'border-opacity-60');
      break;
    default:
      classes.push('bg-neutral-8', 'border-neutral-2', 'border-2', 'border-opacity-60');

      break;
  }

  return <div className={classes.join(' ')}>{children}</div>;
};

Banner.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
};

export default Banner;
